import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import posthog from 'posthog-js';

import './scss/index.scss';
import Color from '@tool/color';
// import moGlobal from '@sub/store/global';
import moUser from '@store/user';
import moStore, { toggleValue } from '@store/index';
import moSkin from '@store/skin';
import { toggleLogin } from '@store/login';

interface IProps {
  label: string;
}
interface IState {}

const BaseButton = styled(Button)(({ theme }) => ({
  fontSize: '14px',
  lineHeight: 1.2,
}));

const DBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: Color.fff,
}));

const DButton = styled(BaseButton)(() => ({
  alignItems: 'center',
  height: '100%',
  // width: '130px',
  padding: 0,

  '& span': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '36px',
    padding: '0 8px',
    flex: 1,
    borderRadius: '5px',
    color: Color.c55,
  },
  '&.active': {
    '& span': {
      fontWeight: 600,
      color: Color.fff,
      backgroundColor: moSkin.mainColor,
    },
  },
  '&:hover': {
    backgroundColor: Color.blackColor(0),
    '& span': {
      color: moSkin.mainColor,
      backgroundColor: `${moSkin.mainColor}1a`,
    },
    '&.active': {
      '& span': {
        color: Color.fff,
        backgroundColor: moSkin.mainColor,
      },
    },
  },
}));

const EButton = styled(DButton)(() => ({
  marginLeft: '40px',

  '& i': {
    marginLeft: '4px',
    padding: '2px',
    borderRadius: '2px',
    fontWeight: 500,
    lineHeight: 1,
    transform: 'scale(0.8)',
    fontSize: '12px',
    fontFamily: 'Roboto',
    color: Color.fff,
    backgroundColor: Color.error,
  },
}));

const FButton = styled(DButton)(() => ({
  marginLeft: '40px',
}));

const SecondHeader = (props: IProps, state: IState) => {
  const navi = useNavigate();
  // const { width, fullWidth } = moGlobal;
  const { isLogin, reportCount, isReportExpired } = moUser;
  const { label } = props;
  const { mainColor } = moSkin;

  useEffect(() => {
    return () => {};
  }, []);

  const onMacro = () => {
    posthog.capture('政策数据 - Tab - 按钮', {});
    window.location.href = '/market/macro';
  };

  const onRecommend = () => {
    posthog.capture('人力资源核心指标 - Tab - 按钮', {});
    window.location.href = '/market';
  };

  const onMarketPay = () => {
    posthog.capture('职位市场薪酬 - Tab - 按钮', {});
    window.location.href = '/market/marketpay';
  };

  const onSalaryBoard = () => {
    posthog.capture('调薪看板 - Tab - 按钮', {});
    window.location.href = '/market/salary-board';
  };

  const onInsight = () => {
    posthog.capture('对标企业招聘动态 - Tab - 按钮', {});
    window.location.href = '/market/insight';
  };

  const onEffect = () => {
    posthog.capture('人效 - Tab - 按钮', {});
    window.location.href = '/effect';
  };

  const onIndex = () => {
    posthog.capture('首页 - Tab - 按钮', {});
    window.location.href = '/dashboard';
  };

  const onHr = () => {
    posthog.capture('hr核心指标 - Tab - 按钮', {});
    window.location.href = '/index/industry-research/0';
  };

  // 定制薪酬报告
  const onJumpCustomreport = () => {
    posthog.capture('定制薪酬报告 - Tab - 按钮', {});
    if (isLogin && reportCount > 0 && !isReportExpired) {
      window.location.href = '/customreport';
    } else {
      window.location.href = '/home/customreport';
    }
  };

  // style={{ width: `${fullWidth}px` }}
  // style={{ width: `${width}px` }}
  return (
    <DBox>
      <section className="second-header_market">
        <EButton
          onClick={onIndex}
          className={[label === 'dashboard' ? 'active' : ''].join(' ')}>
          <span>数据中心<i>NEW</i></span>
        </EButton>
        <b className="line-1515" />
        <EButton
          onClick={onMarketPay}
          className={[label === 'marketpay' ? 'active' : ''].join(' ')}>
          <span>职位薪酬</span>
        </EButton>
        <FButton
          onClick={onRecommend}
          className={[label === 'recommend' ? 'active' : ''].join(' ')}>
          <span>人力核心指标</span>
        </FButton>
        <EButton
          onClick={onEffect}
          className={[label === 'effect' ? 'active' : ''].join(' ')}>
          <span>人效</span>
        </EButton>
        <b className="line-1515" />
        <EButton
          onClick={onInsight}
          className={[label === 'insight' ? 'active' : ''].join(' ')}>
          <span>对标企业招聘动态</span>
        </EButton>
        <EButton
          onClick={onJumpCustomreport}
          className={[label === 'report' ? 'active' : ''].join(' ')}>
          <span>定制薪酬报告</span>
        </EButton>
        {/* <EButton onClick={onHr}
          className={[
            label === 'index' ? 'active' : '',
          ].join(' ')}>
          <span>HR核心指标<i>NEW</i></span>
        </EButton> */}
        {/* <EButton onClick={onSalaryBoard}
          className={[
            label === 'salaryBoard' ? 'active' : '',
          ].join(' ')}>
          <span>年度调薪看板</span>
        </EButton> */}
        <b className="line-1515" />
        <EButton
          onClick={onMacro}
          className={[label === 'macro' ? 'active' : ''].join(' ')}>
          <span>政策数据</span>
        </EButton>
        {/* <Link to="/home/recommend">
          <DButton>订阅</DButton>
        </Link> */}
        {/* <Link to="/home/recommend">
          <DButton>团队成本测算</DButton>
        </Link> */}
      </section>
    </DBox>
  );
};

export default observer(SecondHeader);
